import React, { FC } from "react";

import { QuestionsAssignment } from "@components/main/questions";

const QuestionsAssignmentPage: FC = () => <QuestionsAssignment />;

export default QuestionsAssignmentPage;
